import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const ProductsDataContext = createContext();

const ProductsDataProvider = ({ children }) => {
  const [productData, setProductData] = useState([]);
  const [showBox, setShowBox] = useState(false);

  const getData = async () => {
    const { data } = await axios.get("https://dummyjson.com/products");
    setProductData(data.products);
  };

  useEffect(() => {
    getData();
  }, [showBox]);

  return (
    <ProductsDataContext.Provider value={{ productData, showBox, setShowBox }}>
      {children}
    </ProductsDataContext.Provider>
  );
};

const useProductsData = () => useContext(ProductsDataContext);

export { ProductsDataProvider, useProductsData };
